module.exports = __webpack_public_path__ + "static/media/activityIntro1.6c3a0de3.png";